import type { JSX } from "react";

import { Avatar, type AvatarSize } from "@frontend/components/atoms/Avatar";

import type { ContactOption } from "../types";

export type ContactAvatarProps = {
  contact: ContactOption;
  className?: string;
  size?: AvatarSize;
};

export function ContactAvatar({
  contact,
  className,
  size = "sm",
}: ContactAvatarProps): JSX.Element {
  return (
    <Avatar
      className={className}
      url={contact.hasPhoto ? (contact.avatarUrl ?? undefined) : undefined}
      kind={contact.isOrganization ? "organization" : "person"}
      size={size}
    />
  );
}
